import * as DateUtils from "../dates/utils";
import * as MoneyUtils from "../money/utils";
import { EDisbursementMethod } from "../workers-shared";
import { ECheckStatus } from "./ECheckStatus";

export const getDisbursementLabel = (method: EDisbursementMethod) => {
  switch (method) {
    case EDisbursementMethod.DOWNLOAD_CHECK:
      return "Download check";
    case EDisbursementMethod.PHYSICAL_CHECK:
      return "Physical check";
    case EDisbursementMethod.PREPAID:
      return "Prepaid";
    case EDisbursementMethod.PAYCARD:
      return "Paycard";
    case EDisbursementMethod.INSTANT_PAY:
      return "Instant pay";
    default:
      return "Direct deposit";
  }
};

export const getDisbursementCheckInfoLabel = (method?: EDisbursementMethod) => {
  switch (method) {
    case EDisbursementMethod.DOWNLOAD_CHECK:
      return "Download check";
    case EDisbursementMethod.PHYSICAL_CHECK:
      return "Physical check";
    case EDisbursementMethod.PREPAID:
      return "Prepaid";
    case EDisbursementMethod.PAYCARD:
      return "Paycard";
    case EDisbursementMethod.INSTANT_PAY:
      return "Instant pay";
    default:
      return "Direct deposit";
  }
};

export const getCheckStatusLabel = (status: ECheckStatus) => {
  switch (status) {
    case ECheckStatus.pending:
      return "Pending";
    case ECheckStatus["pre-processed"]:
      return "Pre-processed";
    case ECheckStatus.processed:
      return "Processed";
    case ECheckStatus.processing:
      return "Processing";
    case ECheckStatus.voided:
      return "Voided";
    case ECheckStatus.failed:
      return "Failed";
    default:
      return "Pending";
  }
};

export const getReportingPeriod = ({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}) => {
  if (!startDate && !endDate) return null;

  return `${DateUtils.getUSFormattedDate(
    startDate
  )} - ${DateUtils.getUSFormattedDate(endDate)}`;
};

export const getShiftWageLabel = (wage: number | undefined) =>
  `${MoneyUtils.getCentToDollarWSpace(wage)}/hour`;

export const getShiftHoursLabel = (hours: number | undefined) =>
  `${hours?.toFixed(2) ?? "__"} hours`;
